import { render, staticRenderFns } from "./BulkProductUpload.vue?vue&type=template&id=5e2552ee&scoped=true"
import script from "./BulkProductUpload.vue?vue&type=script&lang=js"
export * from "./BulkProductUpload.vue?vue&type=script&lang=js"
import style0 from "./BulkProductUpload.vue?vue&type=style&index=0&id=5e2552ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2552ee",
  null
  
)

export default component.exports